import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { Box } from "@mui/material";
import React from "react";
import { throttleTime } from "src/utils/utils";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

export const usePassErrorMessageModal = createState({
  isOpen: false,
  errorMessage: "",
  onClose: () => {},
});

export function PassErrorMessageModal() {
  const router = useRouterExt();
  const modalState = usePassErrorMessageModal();
  const [isClosing, setIsClosing] = React.useState(false);

  const onClose = async () => {
    setIsClosing(true);
    modalState?.onClose?.();
    modalState.set({ isOpen: false });
    throttleTime(200, () => {
      modalState.reset();
    });
    setIsClosing(false);
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Error"
      description={<Box py={1}>{modalState.errorMessage}</Box>}
      onClose={onClose}
      slot={{
        primaryButton: {
          isDisabled: isClosing,
          isLoading: isClosing,
          label: "Close",
          onClick: () => onClose(),
        },
        secondaryButton: {
          isHidden: true,
        },
      }}
    />
  );
}
